import type { RouteRecordRaw } from 'vue-router';

const applicationKeysRoutes: RouteRecordRaw[] = [
  {
    path: '/app-key',
    name: 'application-keys',
    component: () => import('@/domains/application-keys/views/ApplicationKeysView.vue'),
    meta: { renderer: 'native' },
  },
];

export default applicationKeysRoutes;
